import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/', name: 'HelloWorld', component: () => import('@/components/HelloWorld')
    },
    {
      path: '/login', name: 'login', component: () => import('@/components/login')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {selector: to.hash}
    } else if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js